import * as Service from '@/App/Service';
import ChalkySticks from '@chalkysticks/sdk';

/**
 * Whether subscription manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize subscription service.
 *
 * @return Promise<void>
 */
export async function initialize(): Promise<void> {
	if (hasInitialized) {
		return;
	}

	await Service.Subscription.initialize();

	// Debug logging for available packages
	ChalkySticks.Utility.Log.debug('subscription', 'Available Subscription Packages:');

	const offerings = await ChalkySticks.Utility.Subscription.getOfferings();

	offerings?.availablePackages.forEach((pkg: ISubscriptionPackage) => {
		ChalkySticks.Utility.Log.debug(
			'subscription',
			`Subscription: ${pkg.product.title}: ${pkg.product.priceString}`,
		);
	});

	hasInitialized = true;
}
